import Vue from "vue";

export default {
  REQUEST_TERMS(state) {
    state.status = "fetching";
  },
  SUCCESS_REQUEST_TERMS(state, { payload, lang }) {
    state.status = "success";
    state.terms = payload.body;
    state.title = Vue.i18n.translate("app.termsAndConditionsLink");
    try {
      var div = document.createElement("div");
      div.innerHTML = state.terms.text;
      const h1 = div.getElementsByTagName("h1");
      if (h1.length) {
        state.title = h1[0].innerText;
      }
    } catch (ignore) {}
    state.termsLang = lang;
  },
  FAILURE_REQUEST_TERMS(state) {
    state.status = "failure";
  },
};
